import { memo } from 'react'

import type { IIconsProps } from './icons.types'

const IconTooltipPointLeft = ({
  width = 6,
  height = 12,
  ...props
}: IIconsProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 6 12'
      {...props}
    >
      <path
        d='M0 6V0L4.58579 4.58579C5.36683 5.36683 5.36684 6.63317 4.58579 7.41421L0 12V6Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default memo(IconTooltipPointLeft)
